import React from 'react';
import ClientUnassign from 'shared/components/client-card/ClientUnassign';
import { connect } from 'react-redux';
import { unassignClientFromNutritionPlan } from 'features/nutrition/ducks/nutritionActions';

class ByClientList extends React.Component {
  handleClientUnassign = clientId => {
    this.props.unassignClientFromNutritionPlan(clientId, this.props.planId);
  };

  render() {
    const { clientsId, clients } = this.props;

    return (
      <ul className="nutrition-client-list">
        {clients.map(client => {
          return clientsId.includes(client.id) ? (
            <li key={client.id}>
              <ClientUnassign
                client={client}
                handleClick={this.handleClientUnassign}
              />
            </li>
          ) : null;
        })}
      </ul>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    unassignClientFromNutritionPlan: (clientId, planId) =>
      dispatch(unassignClientFromNutritionPlan(clientId, planId))
  };
}

export default connect(
  null,
  mapDispatchToProps
)(ByClientList);
